import React from "react";
import { useNavigate } from "react-router-dom";

const Project = ({ project }) => {
  const { img, name, liveSite, description, _id } = project;
  const navigate = useNavigate();
  return (
    <div className="relative border shadow-md rounded project-container text-white  hover:translate-x-2 duration-300  ease-in-out  cursor-pointer">
      <img src={img[0]} className="h-full" alt="project" />
      <div
        className="project-content flex items-center flex-col p-4 "
        style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
      >
        <a href={liveSite} title="Open Live Site" target="_blank">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
        <h2 className="text-xl  text-center ">{name}</h2>
        <small title={description} className=" text-center">
          {description.length > 70
            ? description.slice(0, 70) + "..."
            : description}
        </small>{" "}
        <button
          onClick={() => navigate(`/details/${_id}`)}
          className="py-2 px-4 mt-2  border border-primary bg-transparent   text-xl  rounded duration-300 ease-in-out hover:bg-primary  "
        >
          Project Details
        </button>
      </div>
    </div>
  );
};

export default Project;
